import { render } from "./index.vue?vue&type=template&id=30bc2d8a&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=30bc2d8a&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bc2d8a"]])

export default __exports__